import { data as currencyData } from '@transferz/fe-utils/src/currency/data';
import { useEffect, useState } from 'react';

import { useQueryIPAddressInfo } from '../queries/ip/hooks/useQueryIPAddressInfo';
import { useLocalStorage } from './useLocalStorage';

/**
 * Hook to get the preferred currency code from the local storage.
 * The order of precedence is:
 * 1. URL parameter (if valid currency code)
 * 2. Local storage
 * 3. IP address info
 * 4. Euro as default
 */
export const useLocalPreferredCurrencyCode = () => {
  const [preferredCurrencyCode, setPreferredCurrencyCode]
    = useLocalStorage('preferredCurrency');
  const [regionCurrency, setRegionCurrency] = useState<string>();
  const { refetch: fetchIpAddressInfo } = useQueryIPAddressInfo();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlPreferredCurrencyCode = urlParams
      .get('preferredCurrencyCode')
      ?.toLocaleUpperCase();

    const ipAddressInfoPromise = fetchIpAddressInfo();
    ipAddressInfoPromise.then(({ data: ipAddressInfo }) => setRegionCurrency(ipAddressInfo?.IPAddressInfo?.currencyCode));

    if (
      urlPreferredCurrencyCode
      && urlPreferredCurrencyCode !== preferredCurrencyCode
      && Object.keys(currencyData).includes(urlPreferredCurrencyCode)
    ) {
      setPreferredCurrencyCode(urlPreferredCurrencyCode);
    } else if (!preferredCurrencyCode) {
      ipAddressInfoPromise
        .then(({ data: ipAddressInfo }) => {
          const ipAddressInfoCurrencyCode
            = ipAddressInfo?.IPAddressInfo?.currencyCode;
          ipAddressInfoCurrencyCode
            && setPreferredCurrencyCode(ipAddressInfoCurrencyCode);
        })
        .catch(() => {
          setPreferredCurrencyCode('EUR');
        });
    }
  }, []);

  return [preferredCurrencyCode || 'EUR', setPreferredCurrencyCode, regionCurrency];
};
